import React from "react";
import { Grid, TextField } from "@mui/material";
import { Panel } from "../Panel";

export default function FormikDateMetaFields({ values }) {
  return (
    <Panel>
      <Grid container spacing={2} mt={0}>
        <Grid item xs={12} sm={6}>
          <TextField
            sx={{ width: 1 }}
            name="createdAt"
            label="Created At"
            margin="none"
            value={values?.createdAt}
            disabled={true}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            sx={{ width: 1 }}
            name="updatedAt"
            label="Updated At"
            margin="none"
            value={values?.updatedAt || values?.createdAt}
            disabled={true}
          />
        </Grid>
      </Grid>
    </Panel>
  );
}
